import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/33.mp3"
export default function P1() {
    return (
        <MainLayout
            title="W stronę miasteczka"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p61,
            }}
            content={
                <div>
                    <p>
                        Droga prowadząca w stronę miasteczka leży na wysokiej grobli i wygląda dość pewnie, chociaż gdzieniegdzie i ona chowa się pod wodą.
                    </p>
                    <ul>
                        <li>
                            Spokojnie, ha, ha, myśmy na tę wodę czekali, jak co roku – uśmiecha się Emil, wychodząc z domu. – Ryby będą, trawa urośnie, a i tak każdy ma przy chałupie koryto, łódkę znaczy, i jeśli nie pojedzie wozem, to przepłynie…To znaczy prawie każdy, bo ja akurat swoją pożyczyłem sąsiadom…
                        </li>
                    </ul>
                </div>
            }
        />

    );
}